var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0061 24.75C15.3629 24.75 14.8626 24.2031 14.8626 23.5H13.7191C13.7191 24.9062 14.7197 26 16.0061 26C17.2569 26 18.2932 24.9062 18.2932 23.5H17.1496C17.1496 24.2031 16.6136 24.75 16.0061 24.75ZM23.4746 19.0859C22.4741 18.0703 21.7237 16.9766 21.7237 13.2656C21.7237 10.1797 19.4367 7.64062 16.5779 7.32812V6.625C16.5779 6.3125 16.292 6 16.0061 6C15.6845 6 15.4344 6.3125 15.4344 6.625V7.32812C12.5399 7.64062 10.2529 10.1797 10.2529 13.2656C10.2529 16.9766 9.50249 18.0703 8.50192 19.0859C8.00164 19.6328 7.8587 20.4141 8.10884 21.1172C8.35898 21.8203 9.0022 22.25 9.71689 22.25H22.2954C22.9744 22.25 23.6176 21.8203 23.8677 21.1172C24.1179 20.4141 23.9749 19.6328 23.4746 19.0859ZM22.2954 21H9.71689C9.18088 21 8.93073 20.375 9.28808 19.9844C10.5388 18.6953 11.3964 17.25 11.3964 13.2656C11.3964 10.6484 13.469 8.5 16.0061 8.5C18.5076 8.5 20.5802 10.6484 20.5802 13.2656C20.5802 17.25 21.4378 18.6953 22.6885 19.9844C23.0458 20.375 22.7957 21 22.2954 21Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.b34a4b664b22cf185f52754ce8633ef2.svg";
export { ForwardRef as ReactComponent };